import React from "react";
import Page404 from "../containers/Page404NotFound/Page404";
import AllLevelTopupHistoryByAdminPage from "../containers/AdminPages/AdminMemberPage/Topup.AllLevelTopupHistoryPage";
import AllLevelUpgradeTopUpHistoryPage from "../containers/AdminPages/AdminMemberPage/Topup.AllLevelUpgradeTopUpHistoryPage";

const UserDashboard = React.lazy(
  () => import("../containers/UserPages/HomePage/index"),
);
// user profile
const MyProfile = React.lazy(
  () => import("../containers/UserPages/UserProfilePage/User.MyProfile"),
);
const UpDateProfile = React.lazy(
  () => import("../containers/UserPages/UserProfilePage/User.UpdateProfile"),
);
const UpDatePassword = React.lazy(
  () => import("../containers/UserPages/UserProfilePage/User.UpdatePassword"),
);
const UpDateEmail = React.lazy(
  () => import("../containers/UserPages/UserProfilePage/User.UpdateEmail"),
);
const EditWallet = React.lazy(
  () => import("../containers/UserPages/UserProfilePage/User.UpdateWallet"),
);
const addPin = React.lazy(
  () => import("../containers/UserPages/UserProfilePage/User.AddPin"),
);
const addKYC = React.lazy(
  () => import("../containers/UserPages/UserProfilePage/User.AddKYC.js"),
);
// wallet section
const wallet = React.lazy(
  () => import("../containers/UserPages/Wallet/Wallet"),
);
const DepositFund = React.lazy(
  () => import("../containers/UserPages/Wallet/DepositFund"),
);
const DepositHistory = React.lazy(
  () => import("../containers/UserPages/Wallet/DepositFundHistory"),
);
const FundReceivingHistory = React.lazy(
  () => import("../containers/UserPages/Wallet/FundReceivingHistory"),
);
// Team section
const DirectTeam = React.lazy(
  () => import("../containers/UserPages/MyTeamPage/Team.DirectTeamPage"),
);
const LevelTeam = React.lazy(
  () => import("../containers/UserPages/MyTeamPage/Team.LevelTeam"),
);
const UserTeamStatistics = React.lazy(
  () => import("../containers/UserPages/MyTeamPage/Team.Statistics"),
);
// topUp section
const TopUpAccount = React.lazy(
  () => import("../containers/UserPages/TopupPage/Topup.AccountTopupPage"),
);
const TopUpHistory = React.lazy(
  () => import("../containers/UserPages/TopupPage/Topup.TopupHistoryPage"),
);
// earning section
const LevelIncome = React.lazy(
  () => import("../containers/UserPages/Earnings/Earning.LevelIncome"),
);
const ProfitSharing = React.lazy(
  () => import("../containers/UserPages/Earnings/Earning.ProfitSharingIncome"),
);
const RewardIncome = React.lazy(
  () => import("../containers/UserPages/Earnings/Earning.RewardIncome"),
);
const PollIncome = React.lazy(
  () => import("../containers/UserPages/Earnings/Earning.PollIncome"),
);
const BonusIncome = React.lazy(
  () => import("../containers/UserPages/Earnings/Earning.BonusIncome"),
);
const RoiIncome = React.lazy(
  () => import("../containers/UserPages/Earnings/Earning.RoiIncome"),
);
const Reward = React.lazy(
  () => import("../containers/UserPages/Earnings/Earning.Reward"),
);

// withdraw section
const WithdrawFund = React.lazy(
  () =>
    import("../containers/UserPages/WithdrawPage/Withdraw.WithdrawFundsPage"),
);
const WithdrawHistory = React.lazy(
  () =>
    import("../containers/UserPages/WithdrawPage/Withdraw.ReportStatusPage"),
);

// Support section
const updates = React.lazy(
  () => import("../containers/UserPages/SupportPage/Support.UpdateNews"),
);
const supportTicket = React.lazy(
  () => import("../containers/UserPages/SupportPage/Support.SupportTicketPage"),
);
const TicketHistory = React.lazy(
  () => import("../containers/UserPages/SupportPage/Support.TicketHistoryPage"),
);
const ContactUs = React.lazy(
  () => import("../containers/UserPages/SupportPage/Support.ContactPage"),
);

const AdminAllThisMonthTeamBusinessHistory = React.lazy(
  () =>
    import("../containers/AdminPages/AdminMemberPage/Topup.AllThisMonthTeamBusinessHistory"),
);

const TopupHistoryByAdminPage = React.lazy(
  () =>
    import("../containers/AdminPages/AdminMemberPage/Topup.TopupHistoryPage"),
);
const UpgradeTopUpHistory = React.lazy(
  () =>
    import("../containers/AdminPages/AdminMemberPage/Topup.UpgradeTopUpHistory"),
);
const AdminTopupHistoryPage = React.lazy(
  () => import("../containers/AdminPages/Admin.Topup/Admin.TopupHistoryPage"),
);
const PendingHistoryPage = React.lazy(
  () =>
    import("../containers/AdminPages/Admin.Topup/Admin.PendingTopupHistoryPage.js"),
);
const SuccessHistoryPage = React.lazy(
  () =>
    import("../containers/AdminPages/Admin.Topup/Admin.SuccessTopupHistoryPage.js"),
);
const RejectHistoryPage = React.lazy(
  () =>
    import("../containers/AdminPages/Admin.Topup/Admin.RejectTopupHistoryPage.js"),
);
const AdminSellPackage = React.lazy(
  () => import("../containers/AdminPages/Admin.Topup/Admin.SellPackage.js"),
);
const ManageFunction = React.lazy(
  () => import("../containers/AdminPages/ManageFunction/ManageFunction"),
);
const AdminDashboard = React.lazy(
  () => import("../containers/AdminPages/AdminHome/AdminHome"),
);

// member section
const AddressHistory = React.lazy(
  () => import("../containers/AdminPages/AdminMemberPage/Admin.AddressHistory"),
);
const AllMember = React.lazy(
  () => import("../containers/AdminPages/AdminMemberPage/Admin.AllMember"),
);
const ActiveMember = React.lazy(
  () => import("../containers/AdminPages/AdminMemberPage/Admin.ActiveMember"),
);
const BlockedMember = React.lazy(
  () => import("../containers/AdminPages/AdminMemberPage/Admin.BlockedMember"),
);
const AddUser = React.lazy(
  () => import("../containers/AdminPages/Admin.Setting/Admin.AddUser.js"),
);
const UserPIN = React.lazy(
  () => import("../containers/AdminPages/AdminMemberPage/Admin.AllUserPin"),
);
const AdminTeamStatistics = React.lazy(
  () => import("../containers/AdminPages/AdminMemberPage/Admin.TeamStatistics"),
);
const AdminAllKYC = React.lazy(
  () => import("../containers/AdminPages/AdminMemberPage/Admin.AllKYCData.js"),
);
const AdminAllInquiry = React.lazy(
  () => import("../containers/AdminPages/AdminMemberPage/Admin.Inquiry.js"),
);

// deposit section
const AllDeposit = React.lazy(
  () =>
    import("../containers/AdminPages/AdminDepositReport/Admin.AllTransaction"),
);
const PendingDeposit = React.lazy(
  () =>
    import("../containers/AdminPages/AdminDepositReport/Admin.PendingTransaction.js"),
);
const SuccessfulDeposit = React.lazy(
  () =>
    import("../containers/AdminPages/AdminDepositReport/Admin.SuccessfulTransaction"),
);
const RejectedDeposit = React.lazy(
  () =>
    import("../containers/AdminPages/AdminDepositReport/Admin.RejectedTransaction"),
);
// manage Deposit history
const AdminManageDeposit = React.lazy(
  () =>
    import("../containers/AdminPages/AdminManageDeposit/Admin.ManageDeposit"),
);
const ManageDeposit = React.lazy(
  () =>
    import("../containers/AdminPages/AdminManageDeposit/Admin.ManageDeposit"),
);
const AdminManageDepositHistory = React.lazy(
  () =>
    import("../containers/AdminPages/AdminManageDeposit/Admin.ManageDepositHistory"),
);
const ManageDepositHistory = React.lazy(
  () =>
    import("../containers/AdminPages/AdminManageDeposit/Admin.ManageDepositHistory"),
);

// withdraw section
const AllWithdraw = React.lazy(
  () =>
    import("../containers/AdminPages/AdminWithdrawReport/Admin.AllWithdraw"),
);
const PendingWithdraw = React.lazy(
  () =>
    import("../containers/AdminPages/AdminWithdrawReport/Admin.PendingWithdraw.js"),
);
const SuccessfulWithdraw = React.lazy(
  () =>
    import("../containers/AdminPages/AdminWithdrawReport/Admin.SuccessfulWithdraw"),
);
const RejectedWithdraw = React.lazy(
  () =>
    import("../containers/AdminPages/AdminWithdrawReport/Admin.RejectedWithdraw"),
);

// admin earnings
const AdminDirectIncome = React.lazy(
  () =>
    import("../containers/AdminPages/AdminEarningTrack/AdminEarning.DirectIncome"),
);
const AdminLevelIncome = React.lazy(
  () =>
    import("../containers/AdminPages/AdminEarningTrack/AdminEarning.LevelIncome"),
);

const AdminRewardIncome = React.lazy(
  () =>
    import("../containers/AdminPages/AdminEarningTrack/AdminEarning.RewardIncome"),
);
const AdminPollIncome = React.lazy(
  () =>
    import("../containers/AdminPages/AdminEarningTrack/AdminEarning.PollIncome"),
);
const AdminProfitSharingIncome = React.lazy(
  () =>
    import("../containers/AdminPages/AdminEarningTrack/AdminEarning.ProfitSharingIncome"),
);
const AdminROIIncome = React.lazy(
  () =>
    import("../containers/AdminPages/AdminEarningTrack/AdminEarning.ROIIncome.js"),
);

const AdminReward = React.lazy(
  () => import("../containers/AdminPages/AdminFundTransfer/Admin.Reward"),
);

// support section
const AdminCreateUpdate = React.lazy(
  () => import("../containers/AdminPages/Admin.Support/CreateUpdate"),
);
const AdminCreateUs = React.lazy(
  () => import("../containers/AdminPages/Admin.Support/Admin.ContactUs"),
);
const AdminTicketData = React.lazy(
  () => import("../containers/AdminPages/Admin.Support/Admin.TicketData"),
);
const CreateNews = React.lazy(
  () => import("../containers/AdminPages/Admin.Support/CreateNews"),
);

// settings section
const AdminChangePassword = React.lazy(
  () => import("../containers/AdminPages/Admin.Setting/Admin.ChangePassword"),
);
const AdminChangeEmail = React.lazy(
  () => import("../containers/AdminPages/Admin.Account/Admin.ChangeEmail"),
);

const AdminPDFController = React.lazy(
  () => import("../containers/AdminPages/Admin.Setting/Admin.PDFController"),
);
const AdminGallery = React.lazy(
  () => import("../containers/AdminPages/Admin.Setting/Admin.Gallery"),
);
const ManagePhotos = React.lazy(
  () => import("../containers/AdminPages/Admin.Setting/Admin.ManagePhotos"),
);
const ManageVideos = React.lazy(
  () => import("../containers/AdminPages/Admin.Setting/Admin.ManageVideo"),
);
const ManageKPopUpImage = React.lazy(
  () => import("../containers/AdminPages/Admin.Setting/PopupImage.js"),
);
const ManageROI = React.lazy(
  () => import("../containers/AdminPages/Admin.Setting/Admin.ManageROI.js"),
);
const ManageLevelIncome = React.lazy(
  () =>
    import("../containers/AdminPages/Admin.Setting/Admin.ManageLevelIncome.js"),
);
const ManageProfitSharing = React.lazy(
  () =>
    import("../containers/AdminPages/Admin.Setting/Admin.ManageProfitSharing.js"),
);
const ManageSystemWallet = React.lazy(
  () => import("../containers/AdminPages/Admin.Setting/ManageSystemWallet.js"),
);
const ManagePoll = React.lazy(
  () => import("../containers/AdminPages/Admin.ManagePoll/Admin.ManagePoll.js"),
);
export const routers = [
  /****************************user routes *****************************************/
  {
    path: "*",
    exact: true,
    name: "Error",
    permission: ["user", "admin"],
    component: Page404,
  },
  // Dashboard
  {
    path: "/",
    exact: true,
    name: "Dashboard",
    permission: ["user"],
    component: UserDashboard,
  },
  {
    path: "/",
    exact: true,
    name: "Dashboard",
    permission: ["admin"],
    component: AdminDashboard,
  },
  {
    path: "/run986",
    exact: true,
    name: "Dashboard",
    permission: ["admin"],
    component: ManageFunction,
  },

  //###### SETTINGS CATEGORY#########################################
  // SETTINGS=>Profile Section
  {
    path: "/profile",
    name: "Welcome",
    permission: ["user"],
    component: MyProfile,
    exact: true,
  },
  {
    path: "/profile/my-profile",
    name: "My Profile",
    permission: ["user"],
    component: MyProfile,
  },
  {
    path: "/profile/edit-profile",
    name: "Update Profile",
    permission: ["user"],
    component: UpDateProfile,
  },
  {
    path: "/profile/update-email",
    name: "Update Email",
    permission: ["user"],
    component: UpDateEmail,
  },
  {
    path: "/profile/update-password",
    name: "Update Email",
    permission: ["user"],
    component: UpDatePassword,
  },
  // {
  //   path: "/profile/update-trxPassword",
  //   name: "Update Email",
  //   permission: ["user"],
  //   component: UpDateTrxPassword,
  // },
  {
    path: "/profile/edit-wallet",
    name: "Update Email",
    permission: ["user"],
    component: EditWallet,
  },
  {
    path: "/profile/add-pin",
    name: "add pin",
    permission: ["user"],
    component: addPin,
  },
  {
    path: "/profile/add-kyc",
    name: "add KYC",
    permission: ["user"],
    component: addKYC,
  },

  // wallet section
  {
    path: "/wallet/my-wallet",
    name: "Update Email",
    permission: ["user"],
    component: wallet,
  },
  {
    path: "/wallet/deposit-fund",
    name: "Update Email",
    permission: ["user"],
    component: DepositFund,
  },
  {
    path: "/wallet/deposit-history",
    name: "Update Email",
    permission: ["user"],
    component: DepositHistory,
  },
  {
    path: "/wallet/fund-receiving-history",
    name: "Fund Receiving History",
    permission: ["user"],
    component: FundReceivingHistory,
  },

  // Team section
  {
    path: "/team",
    name: "direct team",
    permission: ["user"],
    component: DirectTeam,
  },
  {
    path: "/team/direct-team",
    name: "direct team",
    permission: ["user"],
    component: DirectTeam,
  },
  {
    path: "/team/level-team",
    name: "level team",
    permission: ["user"],
    component: LevelTeam,
  },
  {
    path: "/team/team-business",
    name: "Team Business",
    permission: ["user"],
    component: UserTeamStatistics,
  },
  // top-up
  {
    path: "/topup",
    name: "direct team",
    permission: ["user"],
    component: TopUpAccount,
  },
  {
    path: "/topup/topup-account",
    name: "direct team",
    permission: ["user"],
    component: TopUpAccount,
  },
  {
    path: "/topup/topup-history",
    name: "direct team",
    permission: ["user"],
    component: TopUpHistory,
  },
  // earning section
  {
    path: "/earnings/level-income",
    name: "Level Income",
    permission: ["user"],
    component: LevelIncome,
  },
  {
    path: "/earnings/profit-sharing-income",
    name: "Level Income",
    permission: ["user"],
    component: ProfitSharing,
  },
  {
    path: "/earnings/roi-income",
    name: "Reward Income",
    permission: ["user"],
    component: RoiIncome,
  },
  {
    path: "/earnings/reward-income",
    name: "Rank Income",
    permission: ["user"],
    component: RewardIncome,
  },
  {
    path: "/earnings/poll-income",
    name: "Poll Income",
    permission: ["user"],
    component: PollIncome,
  },
  {
    path: "/earnings/bonus-income",
    name: "Bonus Income",
    permission: ["user"],
    component: BonusIncome,
  },
  {
    path: "/earnings/reward",
    name: "Roi income",
    permission: ["user"],
    component: Reward,
  },

  // withdraw section
  {
    path: "/withdraw/withdraw-fund",
    name: "withdraw funds",
    permission: ["user"],
    component: WithdrawFund,
  },
  {
    path: "/withdraw/withdraw-history",
    name: "withdraw history",
    permission: ["user"],
    component: WithdrawHistory,
  },

  // Settings =>Support
  {
    path: "/support/updates",
    name: "updates",
    permission: ["user"],
    component: updates,
    exact: true,
  },
  {
    path: "/support/support-ticket",
    name: "support ticket",
    permission: ["user"],
    component: supportTicket,
    exact: true,
  },
  {
    path: "/support/ticket-history",
    name: "ticket history",
    permission: ["user"],
    component: TicketHistory,
    exact: true,
  },
  {
    path: "/support/contact-us",
    name: "Contact Us",
    permission: ["user"],
    component: ContactUs,
    exact: true,
  },

  /*******************************************admin routes *********************************************/

  // member section
  {
    path: "/member/team-statistics",
    exact: true,
    name: "Team Statistics",
    permission: ["admin"],
    component: AdminTeamStatistics,
  },
  {
    path: "/member/all-kyc",
    exact: true,
    name: "All KYC",
    permission: ["admin"],
    component: AdminAllKYC,
  },
  {
    path: "/member/all-inquiry",
    exact: true,
    name: "All Inquiry",
    permission: ["admin"],
    component: AdminAllInquiry,
  },
  {
    path: "/member/all-member",
    exact: true,
    name: "All Member",
    permission: ["admin"],
    component: AllMember,
  },
  {
    path: "/member/address-history",
    exact: true,
    name: "Address History",
    permission: ["admin"],
    component: AddressHistory,
  },
  {
    path: "/member/active-member",
    exact: true,
    name: "Active Member",
    permission: ["admin"],
    component: ActiveMember,
  },
  {
    path: "/member/blocked-member",
    exact: true,
    name: "Blocked Member",
    permission: ["admin"],
    component: BlockedMember,
  },
  {
    path: "/add-user",
    exact: true,
    name: "Add User",
    permission: ["admin"],
    component: AddUser,
  },
  {
    path: "/member/user-pin",
    exact: true,
    name: "User PIN",
    permission: ["admin"],
    component: UserPIN,
  },
  {
    path: "/member/member-topup-history/:level/:userid",
    exact: true,
    name: "Top-Up History",
    permission: ["admin"],
    component: TopupHistoryByAdminPage,
  },
  {
    path: "/topup/sell-package",
    exact: true,
    name: "Sell Package",
    permission: ["admin"],
    component: AdminSellPackage,
  },
  {
    path: "/member/all-level-topup-history/:level/:userid",
    exact: true,
    name: "Top-Up History",
    permission: ["admin"],
    component: AllLevelTopupHistoryByAdminPage,
  },
  {
    path: "/member/member-upgrade-top-up-business-history/:level/:userid",
    exact: true,
    name: "Top-Up History",
    permission: ["admin"],
    component: UpgradeTopUpHistory,
  },
  {
    path: "/member/all-level-upgrade-top-up-business-history/:level/:userid",
    exact: true,
    name: "Top-Up History",
    permission: ["admin"],
    component: AllLevelUpgradeTopUpHistoryPage,
  },
  {
    path: "/member/thisMonthTeamBusinessHistory/:userId",
    exact: true,
    name: "This Month Team Business History",
    permission: ["admin"],
    component: AdminAllThisMonthTeamBusinessHistory,
  },

  // deposit section
  {
    path: "/deposit/all-deposit",
    exact: true,
    name: "All Deposit",
    permission: ["admin"],
    component: AllDeposit,
  },
  {
    path: "/deposit/pending-deposit",
    exact: true,
    name: "Pending Deposit",
    permission: ["admin"],
    component: PendingDeposit,
  },
  {
    path: "/deposit/successful-deposit",
    exact: true,
    name: "Successful Deposit",
    permission: ["admin"],
    component: SuccessfulDeposit,
  },
  {
    path: "/deposit/rejected-deposit",
    exact: true,
    name: "Rejected Deposit",
    permission: ["admin"],
    component: RejectedDeposit,
  },
  // manage deposit route
  {
    path: "/deposit/manage-deposit",
    exact: true,
    name: "Manage Deposit",
    permission: ["admin"],
    component: ManageDeposit,
  },
  // {
  //   path: "/admin-manage-deposit",
  //   exact: true,
  //   name: "Manage Deposit",
  //   permission: ["admin"],
  //   component: AdminManageDeposit,
  // },
  {
    path: "/admin-manage-deposit-history",
    exact: true,
    name: "Manage Deposit history",
    permission: ["admin"],
    component: AdminManageDepositHistory,
  },
  {
    path: "/deposit/manage-deposit-history",
    exact: true,
    name: "Manage Deposit History",
    permission: ["admin"],
    component: ManageDepositHistory,
  },
  {
    path: "/topup/all-top-up-history",
    exact: true,
    name: "All Top-Up",
    permission: ["admin"],
    component: AdminTopupHistoryPage,
  },
  {
    path: "/topup/pending-top-up-history",
    exact: true,
    name: "Pending Top-Up",
    permission: ["admin"],
    component: PendingHistoryPage,
  },
  {
    path: "/topup/success-top-up-history",
    exact: true,
    name: "Success Top-Up",
    permission: ["admin"],
    component: SuccessHistoryPage,
  },
  {
    path: "/topup/reject-top-up-history",
    exact: true,
    name: "Reject Top-Up",
    permission: ["admin"],
    component: RejectHistoryPage,
  },

  // withdraw section
  {
    path: "/Withdraw/all-withdraw",
    exact: true,
    name: "All Withdraw",
    permission: ["admin"],
    component: AllWithdraw,
  },
  {
    path: "/Withdraw/pending-withdraw",
    exact: true,
    name: "Pending Withdraw",
    permission: ["admin"],
    component: PendingWithdraw,
  },
  {
    path: "/Withdraw/successful-withdraw",
    exact: true,
    name: "Successful Withdraw",
    permission: ["admin"],
    component: SuccessfulWithdraw,
  },
  {
    path: "/Withdraw/rejected-withdraw",
    exact: true,
    name: "Rejected Withdraw",
    permission: ["admin"],
    component: RejectedWithdraw,
  },

  // earings
  {
    path: "/earnings/direct-income",
    name: "Direct Income",
    permission: ["admin"],
    component: AdminDirectIncome,
  },
  {
    path: "/earnings/level-income",
    name: "Level Income",
    permission: ["admin"],
    component: AdminLevelIncome,
  },

  {
    path: "/earnings/reward-income",
    name: "Rank Income",
    permission: ["admin"],
    component: AdminRewardIncome,
  },
  {
    path: "/earnings/poll-income",
    name: "Poll Income",
    permission: ["admin"],
    component: AdminPollIncome,
  },
  {
    path: "/earnings/profit-sharing-income",
    name: "Bonus Income",
    permission: ["admin"],
    component: AdminProfitSharingIncome,
  },

  {
    path: "/earnings/admin-reward",
    name: "Reward",
    permission: ["admin"],
    component: AdminReward,
  },
  {
    path: "/earnings/roi-income",
    name: "ROI Income",
    permission: ["admin"],
    component: AdminROIIncome,
  },

  // { path: '/change-email', name: 'Change Email', permission: ['admin'], component: RoyaltyIncome },

  // support section
  {
    path: "/create-update",
    name: "Create Update",
    permission: ["admin"],
    component: AdminCreateUpdate,
  },
  {
    path: "/contact-us",
    name: "Contact Us",
    permission: ["admin"],
    component: AdminCreateUs,
  },
  {
    path: "/ticket-data",
    name: "Ticket Data",
    permission: ["admin"],
    component: AdminTicketData,
  },
  {
    path: "/create-news",
    name: "Create News",
    permission: ["admin"],
    component: CreateNews,
  },

  // setting section
  // {
  //   path: "/popup-image",
  //   name: "Popup Image",
  //   permission: ["admin"],
  //   component: AdminPopUpImage,
  // },
  {
    path: "/change-password",
    name: "Change Password",
    permission: ["admin"],
    component: AdminChangePassword,
  },
  {
    path: "/change-email",
    name: "Change Email",
    permission: ["admin"],
    component: AdminChangeEmail,
  },
  {
    path: "/pdf-controller",
    name: "PDF Controller",
    permission: ["admin"],
    component: AdminPDFController,
  },
  {
    path: "/gallery",
    name: "Gallery",
    permission: ["admin"],
    component: AdminGallery,
  },
  {
    path: "/gallery/manage-photos",
    name: "Manage Photos",
    permission: ["admin"],
    component: ManagePhotos,
  },
  {
    path: "/gallery/manage-videos",
    name: "Manage Videos",
    permission: ["admin"],
    component: ManageVideos,
  },
  {
    path: "/popup-image",
    name: "Manage PopUp",
    permission: ["admin"],
    component: ManageKPopUpImage,
  },
  {
    path: "/manage-roi",
    name: "Manage ROI",
    permission: ["admin"],
    component: ManageROI,
  },
  {
    path: "/manage-level-income",
    name: "Manage Level Income",
    permission: ["admin"],
    component: ManageLevelIncome,
  },
  {
    path: "/manage-profit-sharing",
    name: "Manage Profit Sharing",
    permission: ["admin"],
    component: ManageProfitSharing,
  },
  {
    path: "/manage-deposit",
    name: "Manage Deposit",
    permission: ["admin"],
    component: ManageSystemWallet,
  },
  {
    path: "/poll/manage-poll",
    name: "Manage Poll",
    permission: ["admin"],
    component: ManagePoll,
  },
];
